// Demo Mode Analytics Events
const DEMO_NUDGE_SHOWN = 'Demo Nudge Shown';
const DEMO_NUDGE_ACCEPTED = 'Demo Nudge Accepted';
const DEMO_NUDGE_SKIPPED = 'Demo Nudge Skipped';
const DEMO_WELCOME_SHOWN = 'Demo Welcome Shown';
const DEMO_WELCOME_DISMISSED = 'Demo Welcome Dismissed';
const DEMO_TOUR_STARTED = 'Demo Tour Started';
const DEMO_TOUR_COMPLETED = 'Demo Tour Completed';
const DEMO_TOUR_SKIPPED = 'Demo Tour Skipped';
const DEMO_MODE_ENTERED = 'Demo Mode Entered';
const DEMO_MODE_EXITED = 'Demo Mode Exited';

// Feature Discovery Events
const DEMO_ANALYTICS_VIEWED = 'Demo Analytics Viewed';

export const DEMO_MODE_EVENTS = {
  DEMO_NUDGE_SHOWN,
  DEMO_NUDGE_ACCEPTED,
  DEMO_NUDGE_SKIPPED,
  DEMO_WELCOME_SHOWN,
  DEMO_WELCOME_DISMISSED,
  DEMO_TOUR_STARTED,
  DEMO_TOUR_COMPLETED,
  DEMO_TOUR_SKIPPED,
  DEMO_MODE_ENTERED,
  DEMO_MODE_EXITED,
  DEMO_ANALYTICS_VIEWED,
};
